import { useGenerateUploadDailyFormWorkOrderFileUrlMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useGenerateUploadDailyFormWorkOrderFileUrl() {
  const [mutation, { loading, data, error }] = useGenerateUploadDailyFormWorkOrderFileUrlMutation();

  const [generateUploadDailyFormWorkOrderFileUrl, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "generateUploadDailyFormWorkOrderFileUrl",
    },
    {
      hideMessage: true,
    }
  );

  return [generateUploadDailyFormWorkOrderFileUrl, context] as const;
}
